<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    桂湾站<br>
站点介绍<br>
桂湾站位于深圳市南山区听海大道与桂湾四路交叉路口，车站周边以商业、办公为主。东南面为华润前海中心，东北面为前海交易广场，西面为前海金融中心，西北面为11号线下沉广场。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:16	00:09	5号线	3分钟	5分25秒<br>
黄贝岭	06:26	23:12	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:20	00:09	5号线	4分钟	6分钟<br>
黄贝岭	06:31	23:12	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:20	01:09	5号线	4分钟	6分钟<br>
黄贝岭	06:31	00:12	5号线	4分钟	6分钟<br><br>

站点出口信息<br>
A出入口:<br>
桂湾四路南侧（东）、听海大道东侧（南）、万象前海<br><br>
B出入口:<br>
桂湾四路北侧（东）<br><br>
C出入口:<br>
听海大道西侧（北）<br><br>
D出入口:<br>
桂湾四路北侧（西）<br><br>
E出入口:<br>
桂湾四路南侧（西）、听海大道西侧（南）、前海党群服务中心、前海鸿荣源中心、卓越前海壹号、 华润前海中心、弘毅大厦、前海大厦、前海国际人才港、深圳国际仲裁院/华南国际经济贸易仲裁委员会<br><br>
公交换乘信息<br>
D出入口:<br>
公交站名： 前海交易广场<br>
B992<br><br>
E出入口:<br>
公交站名： 桂湾地铁站<br>
B992<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


